import { render, staticRenderFns } from "./AdvancedSearchPeopleCardResults.vue?vue&type=template&id=6e923223&scoped=true&"
import script from "./AdvancedSearchPeopleCardResults.vue?vue&type=script&lang=js&"
export * from "./AdvancedSearchPeopleCardResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e923223",
  null
  
)

export default component.exports